class ContactForm extends HTMLElement {
  constructor() {
    super();

    this.countrySelect = this.querySelector('[data-contact-country]');
    this.countrySelectWrapper = this.querySelector('[data-contact-country-wrapper]');
    this.provinceSelect = this.querySelector('[data-contact-province]');
    this.provinceContainer = this.querySelector('[data-contact-province-container]');
    this.contactPhone = this.querySelector('#ContactPhone');
    this.fullPhoneInput = this.querySelector('#ContactForm-phone-full');
    this.selector = this.dataset.selector;
    this.formId = this.dataset.formId;
    this.form = this.querySelector(`#${this.formId}`);
    this.formWrapper = this.querySelector('[data-form-wrapper]');

    if (!this.countrySelect || !this.provinceSelect || !this.provinceContainer) {
      return;
    }

    this.#init();
  }

  #init() {
    this.#initCountryProvince();
    this.#initTelInput();
    this.#checkValidity();
  }

  #checkValidity() {
    if (!this.form) return;

    this.form.addEventListener('submit', (e) => {
      this.form
        .querySelectorAll(`.${this.selector}__error--active`)
        .forEach(el => el.classList.remove(`${this.selector}__error--active`));

      this.form
        .querySelectorAll(`.${this.selector}__column--error`)
        .forEach(el => el.classList.remove(`${this.selector}__column--error`));

      if (this.selector === 'wholesale-form') {
        const checkboxesError = this.form.querySelector('.wholesale-form__error--checkboxes');

        if (checkboxesError) {
          checkboxesError.textContent = '';
        }
      }

      const inputs = this.form.querySelectorAll(
        'input[required], textarea[required], select[required]'
      );

      let customInvalidInput = null;

      if (this.selector === 'wholesale-form') {
        const groupCheckboxes = this.form.querySelectorAll('input[name="contact[where_will_you_sell]"]');
        const isAnyChecked = [...groupCheckboxes].some(input => input.checked);

        groupCheckboxes.forEach(input => input.setCustomValidity(''));

        if (!isAnyChecked && groupCheckboxes.length > 0) {
          const firstCheckbox = groupCheckboxes[0];

          firstCheckbox.setCustomValidity('Please select at least one option.');
          customInvalidInput = firstCheckbox;
        }
      }

      let invalidInput = [...inputs].find(input => !input.checkValidity());

      if (!invalidInput && customInvalidInput) {
        invalidInput = customInvalidInput;
      }

      if (!invalidInput) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const wrapper = invalidInput.closest(`.${this.selector}__column`);
      const message = wrapper?.querySelector(`.${this.selector}__error`);

      invalidInput.focus({ preventScroll: true });

      invalidInput.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });

      if (message) {
        message.textContent = invalidInput.validationMessage;
        wrapper.classList.add(`${this.selector}__column--error`);
        message.classList.add(`${this.selector}__error--active`);
      } else if (
        this.selector === 'wholesale-form' &&
        invalidInput.name === 'contact[where_will_you_sell]'
      ) {
        const checkboxesError = this.form.querySelector('.wholesale-form__error--checkboxes');

        if (checkboxesError) {
          checkboxesError.textContent = invalidInput.validationMessage;
          checkboxesError.classList.add('wholesale-form__error--active');
        }
      }
    });
  }

  #initCountryProvince() {
    if (!window.Shopify || !Shopify.CountryProvinceSelector) return;

    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector(
      this.countrySelect.id,
      this.provinceSelect.id,
      {
        hideElement: this.provinceContainer.id,
      }
    );

    this.#syncProvinceVisibility();

    this.observer = new MutationObserver(() => {
      this.#syncProvinceVisibility();
    });

    this.observer.observe(this.provinceContainer, {
      attributes: true,
      attributeFilter: ['style', 'hidden'],
    });
  }

  #syncProvinceVisibility() {
    const isHidden =
      this.provinceContainer.hasAttribute('hidden') ||
      this.provinceContainer.style.display === 'none';

      this.countrySelectWrapper.classList.toggle(
        `${this.selector}__column--wide`,
      isHidden
    );
  }

  #initTelInput() {
    if (!this.contactPhone || !window.intlTelInput) {
      console.warn('intlTelInput not available');
      return;
    }

    const utilsSrc = this.contactPhone.dataset.utils;

    this.iti = window.intlTelInput(this.contactPhone, {
      initialCountry: 'us',
      nationalMode: true,
      formatOnDisplay: true,
      autoPlaceholder: 'polite',
      separateDialCode: true,
      utilsScript: utilsSrc ? `https:${utilsSrc}` : undefined,
    });

    this.contactPhone.addEventListener('countrychange', () => {
      this.#syncFullPhone();
    });

    this.contactPhone.addEventListener('input', () => {
      this.#syncFullPhone();
    });
  }

  #syncFullPhone() {
    if (!this.contactPhone || !this.iti) return;

    const number = `+${this.iti.getSelectedCountryData().dialCode}${this.contactPhone.value}`;

    if (number) {
      this.fullPhoneInput.value = number;
    }
  }
}

customElements.define('contact-form', ContactForm);

